<template>
  <div class="col-lg-10" style="margin-top: 20px; margin-left: -30px;">
    <br />
    <el-form :inline="true" size="mini" :model="search" class="demo-form-inline" style="margin: 0 -15px;">
      <el-form-item label="出发日期">
        <el-date-picker v-model="search.ChuFaRiQi_S" type="date" style="width:150px !important;" placeholder="出发日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="至">
        <el-date-picker v-model="search.ChuFaRiQi_E" type="date" style="width:150px !important;" placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="关键字">
        <el-input v-model="search.Keyword" placeholder="出发地、到达地"></el-input>
      </el-form-item>
      <el-form-item label="是否有效">
        <el-select v-model="search.IsYouXiao" placeholder="请选择">
          <el-option v-for="item in EnabledStatus" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="row" v-loading="showLoading">
      <div class="JY-items-list" v-for="item in items" :key="item.ID">
        <a href="javascript:;" @click="openDetail(item)">
          <h3>
            <el-tag size="mini" type="danger" v-if="item.IsExpired">已过期</el-tag>
            <el-tag size="mini" v-if="item.PingTaiBaoJia" >平台报价:{{item.BaoJiaLeiXing==1?('总计￥'+item.PingTaiBaoJia):('￥'+item.PingTaiBaoJia+'/吨')}}</el-tag>
            <el-tag size="mini" :type="stateType(item.Status)">{{item.DisplayStatus}}</el-tag>
            {{item.SourceGoodsNo}} {{item.ChuFaDi}} - {{item.DaoDaDi}}
            <span class="pull-right">{{item.CreateTime}}</span>
          </h3>
        </a>
        <div>出发时间-到达时间：{{item.ChuFaRiQi}} - {{item.DaoDaRiQi}}</div>
        <div>订单有效期：{{item.YouXiaoQiStart}} - {{item.YouXiaoQiEnd}}</div>
        <div>货物种类：{{item.GoodsType}}</div>
        <div>是否同意平台报价：{{item.IsAgree}}</div>
        <div>
          <el-button v-if="item.CanCancel" type="primary" @click="cancelPub(item)">取消发布</el-button>
          <el-button type="primary" @click="copyGoodsSource(item.ID)">复制货源</el-button>
        </div>
      </div>
    </div>
    <div class="row mt10">
      <el-pagination @current-change="loadMore" background
        :page-size="search.PageSize" layout="total, prev, pager, next" :total="itemCount"></el-pagination>
    </div>
    <el-dialog title="货源详情" width="70%" top="1vh" :visible.sync="dialogVisible">
      <div v-if="selectedGood.Status==2" class="tip">
        <el-tag type="danger">审核未通过，原因:{{selectedGood.YuanYin}}</el-tag>
      </div>
      <div v-if="selectedGood.PingTaiBaoJia!=null" class="width_44"
        style="position: absolute; bottom: 40px; right: 40px; z-index: 999; text-align: right;">
        <div class="JY-offer">
          <h2>价格明细</h2>
          <div>
            <p>
              <span>有效期起：</span>
              <font>{{selectedGood.S_YouXiaoQiStart}}</font>
              <span>有效期止：</span>
              <font>{{selectedGood.S_YouXiaoQiEnd}}</font>
              <br />
              <span>备注：</span>
              <font>{{selectedGood.S_Text}}</font>
            </p>
          </div>
        </div>
        <div style="padding: 6px 0;">
          <el-checkbox v-if="!selectedGood.IsAgree" v-model="inputAgree">查看并同意</el-checkbox>
          <a href="javascript:;" @click="openCondition">《网络货运电子委托协议》</a>
        </div>
        <br />
        <el-tag class="price" type="danger" style="position: absolute; height: 40px; line-height: 40px; padding: 0 10px; margin-top: 10px; right: 116px; bottom: 0px;">
          平台报价是{{selectedGood.PingTaiBaoJia}}元
        </el-tag>
        <el-button v-if="!selectedGood.IsAgree" :disabled="!inputAgree" type="primary" @click="confirmPrice">确认报价</el-button>
        <el-button v-else disabled="disabled" type="success">已同意报价</el-button>
      </div>
      <good-detail :good="selectedGood" :images="selectedGoodImages"></good-detail>
      <el-button
        @click="gotoEdit(selectedGood.ID)"
        v-if="selectedGood.Status!=3"
        style="margin-left:375px;margin-top:10px"
        type="primary"
      >编辑货源</el-button>
    </el-dialog>
    <el-dialog title="电子运单契约条款" :visible.sync="conditionDialogVisible" width="70%" center>
      <condition :id="conditionId" 
      :SourceGoodsNo="selectedGood.SourceGoodsNo" :HuoZhu="selectedGood.HuoZhu" 
      :CreateTime="selectedGood.CreateTime"
      :Description="selectedGood.Description"
      :ChuFaDi="selectedGood.ChuFaDi"
      :ChuFaDiAddr="selectedGood.ChuFaDiAddr"
      :DaoDaDi="selectedGood.DaoDaDi"
      :DaoDaDiAddr="selectedGood.DaoDaDiAddr"
      :ChuFaRiQi="selectedGood.ChuFaRiQi"
      :DaoDaRiQi="selectedGood.DaoDaRiQi"
      :GongLiShu="selectedGood.GongLiShu"
      :BaoJiaLeiXingName="selectedGood.BaoJiaLeiXingName"
      ></condition>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api";
import goodDetail from "../../components/goodDetail";
import condition from "../../components/condition";
export default {
  components: {
    goodDetail,
    condition
  },
  data() {
    return {
      inputAgree: false,
      conditionDialogVisible: false,
      conditionId: "",
      selectedGood: {},
      selectedGoodImages: [],
      showLoading: false,
      dialogVisible: false,
      choosedOrderId: "",
      items: [],
      EnabledStatus: [
        { label: "全部", value: "" },
        { label: "有效", value: "0" },
        { label: "无效", value: "1" }
      ],
      itemCount: 0,
      search: {
        PageNo: 1,
        PageSize: 10,
        SortField: "createtime",
        SortBy: "desc"
      }
    };
  },
  methods: {
    openCondition() {
      //this.conditionId = "5486be38-7fa5-45cb-87fc-de7099f24a80";
      this.conditionId = "0E28FA6A-B7FC-4D8F-97CE-BA966B03B392";
      this.conditionDialogVisible = true;
    },
    gotoEdit(id) {
      this.$router.push("/shipper/form?id=" + id);
    },
    stateType: function(state) {
      switch (state) {
        case 0:
          return "info";
        case 1:
          return "success";
        case 2:
          return "danger";
        case 3:
          return "warning";
      }
    },
    confirmPrice() {
      let _this = this;
      _this.$confirm("确认报价，此操作不能撤销?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          api.agreePrice({sourceGoodId: _this.selectedGood.ID}).then(res => {
            if (res.data.Succeed) {
              _this.selectedGood.IsAgree = 1;
              _this.$message({
                type: "success",
                message: "操作成功!"
              });
            }
          });
        }).catch(() => {});
    },
    loadItems() {
      let _this = this;
      _this.showLoading = true;
      api.searchSourceGoods(_this.search).then(res => {
        _this.showLoading = false;
        if (res.data.Succeed) {
          _this.items = res.data.Data.Data;
          _this.itemCount = res.data.Data.totalItemCount;
        } else {
          _this.$message({
            message: res.data.Message,
            type: "error"
          });
        }
      });
    },
    reload() {
      this.search.PageNo = 1;
      this.loadItems();
    },
    loadMore(n) {
      this.search.PageNo = n;
      this.loadItems();
    },
    openDetail(item) {
      let _this = this;
      _this.showLoading = true;
      api.getSourceGood({id: item.ID}).then(res => {
          this.dialogVisible = true;
          _this.showLoading = false;
          _this.selectedGood = res.data.Data.Data;
          
          if(_this.selectedGood.HuoZhu==undefined){
            _this.selectedGood.HuoZhu=''
          }
          if(_this.selectedGood.UpdateTime==undefined){
            _this.selectedGood.UpdateTime=''
          }
          _this.selectedGoodImages = [];
          if (res.data.Data.Attachments) {
            res.data.Data.Attachments.forEach(item => {
              _this.selectedGoodImages.push({
                AttID: item.AttID,
                AttName: item.AttName,
                TypeName: item.TypeName,
                Url: process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID
              });
            });
          }
        });
    },
    cancelPub(item){
      let _this = this;
      _this.showLoading = true;
      api.disabledSourceGoods({id: item.ID}).then(res => {
        if(!res.data.Succeed){
          _this.$message({
            message: res.data.Message,
            type: "error"
          });
        }
        this.loadItems();
        _this.showLoading = false;
      });
    },
    copyGoodsSource(id){
      this.$router.push("/shipper/form?copyid="+id)
    },
  },

  mounted() {
    this.loadItems();
  }
};
</script>

<style scoped>
span.el-tag {
  margin-right: 5px;
}
#btn_search {
  margin-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.JY-items-list,
.JY-items-search {
  width: 100%;
}
.hasPrice {
  color: #409eff;
  float: left;
  display: inline-block;
  margin-top: 3px;
  margin-right: 10px;
}
.status0 {
  color: #e6a23c;
}
.status1 {
  color: #67c23a;
}
.status2 {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/pages/Shipper/ShipperGoods.vue